import { useEffect, useState, useCallback } from 'react'
import { Anomaly } from '../types/anomaly'

interface AnomalySocketData {
  anomalies: Anomaly[]
  isConnected: boolean
}

export const useAnomalySocket = () => {
  const [data, setData] = useState<AnomalySocketData>({
    anomalies: [],
    isConnected: false
  })
  const [socket, setSocket] = useState<WebSocket | null>(null)

  const connect = useCallback(() => {
    // WebSocket connection disabled - start Django with ASGI support to enable
    console.log('WebSocket connection disabled - start Django with ASGI support')
    return
  }, [socket])

  const disconnect = useCallback(() => {
    if (socket) {
      socket.close()
      setSocket(null)
      setData(prev => ({ ...prev, isConnected: false }))
    }
  }, [socket])

  useEffect(() => {
    // Temporarily disabled - enable when ASGI server is running
    // connect()
    
    return () => {
      disconnect()
    }
  }, [])

  return {
    anomalies: data.anomalies,
    isConnected: data.isConnected,
    connect,
    disconnect
  }
}